import { createFileRoute, redirect } from '@tanstack/react-router'

import { isPrivilegedUser } from '@/auth'

export const Route = createFileRoute('/')({
  loader: ({ context: { auth } }) => {
    redirect({
      to: isPrivilegedUser(auth) ? '/recipes' : '/usage-statistics/engagement',
      throw: true,
    })
  },
})
